<template>
  <v-container fluid>
    <h2 class="my-10">Төгсөгчөөс элсэх бүртгэл</h2>
    <v-row class="mb-4">
      <v-col>
        <v-btn
          class="bg-gradient-info mr-4"
          dark
          @click="_saveRegisterSaveToESIS"
          >Элсэx бүртгэл xадгалаx</v-btn
        >
        <v-btn class="bg-gradient-danger mr-4" dark @click="_checkState"
          >Төлөв шалгах</v-btn
        >
      </v-col>
    </v-row>
    <v-data-table
      v-if="$attrs.classStudents"
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
    >
      <template slot="item" slot-scope="props">
        <tr>
          <td style="width: 2%">{{ props.index + 1 }}</td>
          <td>
            {{ props.item.name }} /<span class="blue--text">{{
              props.item.REGISTER
            }}</span
            >/
          </td>

          <td>
            <v-select
              :items="actionReasons"
              v-model="props.item.actionReason"
              return-object
              item-text="ACTION_REASON_NAME"
              item-value="ACTION_REASON_ID"
              label="Шалтгаан сонгоx"
            >
              <template #item="{ item }">
                <p>
                  {{ item.ACTION_NAME }}:
                  <span class="blue--text">{{ item.ACTION_REASON_NAME }}</span>
                </p>
              </template>
            </v-select>
          </td>
          <td v-if="props.item.actionReason" class="blue--text">
            {{ props.item.actionReason.ACTION_NAME }}
          </td>

          <td v-if="props.item.actionReason">
            {{ props.item.actionReason.ACTION_ID }}/
            <span class="blue--text">{{
              props.item.actionReason.ACTION_REASON_ID
            }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="showStateCheckDialog"
      max-width="1200px"
      v-if="stateCheckResponseData"
    >
      <v-card>
        <v-card-title class="headline">
          Төгсөлтийн бүртгэлийн төлөв
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="stateCheckHeaders"
            :items="stateCheckResponseData"
            class="elevation-1"
            item-key="PERSON_ID"
          >
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showStateCheckDialog = false">
            Xааx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return {
      defaultReason: {
        ACTION_ID: 1009,
        ACTION_NAME: "Төгсөөд гарах",
        ACTION_REASON_ID: 79,
        ACTION_REASON_NAME: "Хөтөлбөр амжилттай дүүргэсэн",
        ACTION_CODE: "GRADUATE_EXIT",
      },
      showStateCheckDialog: false,
      stateCheckResponseData: null,
      headers: [
        { text: "№", value: "index" },
        { text: "Суралцагч", value: "name" },
        { text: "Шалтгаан", value: "decision_number" },

        { text: "Төлөв", value: "actionCode" },
        { text: "Үйлдэл", value: "action" },
        // { text: "Үйлдлийн огноо", value: "date" },
      ],
      actionReasons: [
        {
          ACTION_ID: 1004,
          ACTION_NAME: "Төгсөөд элсэх",
          ACTION_REASON_ID: 79,
          ACTION_REASON_NAME: "Хөтөлбөр амжилттай дүүргэсэн",
          ACTION_CODE: "GRADUATE",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 48,
          ACTION_REASON_NAME: "Эрүүл мэндийн шалтгаанаар",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 62,
          ACTION_REASON_NAME: "Гэмт хэрэгт холбогдсон",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 80,
          ACTION_REASON_NAME: "Амьдралын шаардлагаар",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 110,
          ACTION_REASON_NAME: "Сурлагын амжилт хангалтгүй",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 111,
          ACTION_REASON_NAME: "Хичээл дутуу судалсан",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 112,
          ACTION_REASON_NAME: "Шалгалт өгөөгүй(Төгсөх эсвэл дэвших)",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 113,
          ACTION_REASON_NAME: "Ирэхээ больсон",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 128,
          ACTION_REASON_NAME: "Нас хүрээгүй шалтгаанаар",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1005,
          ACTION_NAME: "Давтан суралцах",
          ACTION_REASON_ID: 130,
          ACTION_REASON_NAME: "Эцэг, эхийн хүсэлтээр",
          ACTION_CODE: "ATTEMPT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 2,
          ACTION_REASON_NAME: "Цэргийн жинхэнэ албанд татагдсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 16,
          ACTION_REASON_NAME: "Мэдээллийг буруу оруулсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 48,
          ACTION_REASON_NAME: "Эрүүл мэндийн шалтгаанаар",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 61,
          ACTION_REASON_NAME: "Нас барсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 62,
          ACTION_REASON_NAME: "Гэмт хэрэгт холбогдсон",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 63,
          ACTION_REASON_NAME: "Ажил эрхлэхээр",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 64,
          ACTION_REASON_NAME: "Сургалтын төлбөр төлөөгүй",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 65,
          ACTION_REASON_NAME: "Сургалтын байгууллагын шийдвэрээр",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 67,
          ACTION_REASON_NAME: "Сурах дургүйгээс",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 70,
          ACTION_REASON_NAME: "Ар гэрийн гачигдал",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 75,
          ACTION_REASON_NAME: "Шилжиж явсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 77,
          ACTION_REASON_NAME: "Сахилгын арга хэмжээ авсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 80,
          ACTION_REASON_NAME: "Амьдралын шаардлагаар",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 97,
          ACTION_REASON_NAME: "Сураггүй болсон",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1008,
          ACTION_NAME: "Давтан сурахаар гарах",
          ACTION_REASON_ID: 99,
          ACTION_REASON_NAME: "Бусад улс руу шилжиж явсан",
          ACTION_CODE: "ATTEMPT_EXIT",
        },
        {
          ACTION_ID: 1009,
          ACTION_NAME: "Төгсөөд гарах",
          ACTION_REASON_ID: 79,
          ACTION_REASON_NAME: "Хөтөлбөр амжилттай дүүргэсэн",
          ACTION_CODE: "GRADUATE_EXIT",
        },
      ],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  methods: {
    async _saveRegisterSaveToESIS() {
      var inStudentList = [];
      for (const stud of this.$attrs.classStudents) {
        stud.actionReason = this.defaultReason;
        inStudentList.push({
          person_id: Number(stud.PERSON_ID),
          action_id: stud.actionReason.ACTION_ID,
          action_reason_id: stud.actionReason.ACTION_REASON_ID,
          student_group_id: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        });

        var urlLink =
          this.$store.state.domainESISAddress +
          "/svc/api/hub/student/enrollment/save";

        console.log("writing to...", urlLink);

        //if successfull update firebase
        // var batch = fb.db.batch();
        // for (var student of this.$attrs.classStudents) {
        //   batch.update(student.ref, {
        //     devshiltDecisionNumber: student.decision_number,
        //     devshiltDecision: student.decision,
        //     devshiltReason: student.reason,
        //     nextClassGroupId: student.nextClassGroup
        //       ? student.nextClassGroup
        //       : null,
        //     savedAt: new Date(),
        //     savedToESISAt: new Date(),
        //     savedToESIS: true,
        //   });
        // }
      }
      var bodyData = {
        studentGroupId: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        inStudentList: inStudentList,
      };
      console.log(bodyData);

      await this.writeToESIS(urlLink, bodyData);
    },
    async writeToESIS(urlLink, bodyData) {
      var startTime = new Date();
      await axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esisWrite",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
            data: bodyData,
          }
        )
        .then((res) => {
          this.loading = false;
          var diff = this.timeDifference(startTime, new Date());
          console.log(
            "RESPONSE from ESIS",
            res,
            res.status == 200,
            res.data.SUCCESS_CODE
          );
          this.saveESISresponse = res;
          this.$swal.fire({
            title: res.data.RESPONSE_MESSAGE,
            text: res.data.RESULT + "<p>" + diff + "</p>",
          });
          // this.showSaveESISResponseDialog = !this.showSaveESISResponseDialog;
        })
        .catch((error) => {
          console.log(this.$attrs.tokenData.token);
          console.log(bodyData);
          console.error("Error:", error);
          this.$swal.fire({
            title: error.code,
            text: error.response.data,
            icon: "error",
          });
          //errorhandling write to firebase
        });
    },
    timeDifference(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffMs = end - start;

      // const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      return `${minutes}m ${seconds}s`;
    },

    _checkState() {
      this.statecheckResponseData = null;
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/student/enrollment/list/" +
        this.$attrs.selectedClassGroup.STUDENT_GROUP_ID;
      console.log("urlLink", urlLink);
      //ftodo
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
          }
        )
        .then((res) => {
          console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
          if (res && res.data && res.data.SUCCESS_CODE == 200) {
            this.stateCheckResponseData = res.data.RESULT;
            this.showStateCheckDialog = true;
          } else this.$swal.fire(res.data.RESPONSE_MESSAGE, "error");
        });
    },
  },
};
</script>
